import { render, staticRenderFns } from "./PassionProjectRecommendationModal.vue?vue&type=template&id=b3927ae2&scoped=true"
import script from "./PassionProjectRecommendationModal.vue?vue&type=script&lang=js"
export * from "./PassionProjectRecommendationModal.vue?vue&type=script&lang=js"
import style0 from "./PassionProjectRecommendationModal.vue?vue&type=style&index=0&id=b3927ae2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3927ae2",
  null
  
)

export default component.exports